import { useEffect, useState } from 'react';
import { useGetRequisitionDocumentsMutation } from '@Features/MaterialRequest/requests/MaterialRequisition/store/api/MaterialRequestApiSlice';
import { currentMaterialRequest } from '@Features/MaterialRequest/requests/MaterialRequisition/store/selectors/materialRequestSelector';
import { useAppSelector } from '@Hooks/index';
import { getModalRecordKey } from '@Store/selectors/modalSelector';
import { MaterialRequisitionDocumentResponse } from '@Types/api/form';

import { getFileTypeExt } from '@Features/utils/document';
import MaterialDocumentItem from './MaterialDocumentItem';

interface ViewModalContentProps {}

const ViewModalContent: React.FC<ViewModalContentProps> = () => {
  const currentMRequest = useAppSelector(currentMaterialRequest);
  const documentId = useAppSelector(getModalRecordKey);
  const [getRequisitionDocuments] = useGetRequisitionDocumentsMutation();
  const [documentItem, setDocumentItem] =
    useState<MaterialRequisitionDocumentResponse>();

  useEffect(() => {
    if (currentMRequest?.requestId) {
      getRequisitionDocuments(String(currentMRequest?.requestId))
        .unwrap()
        .then((response) => {
          const findedDocument = response.find(
            (document) => document.filePath === documentId
          );
          setDocumentItem(findedDocument);
        });
    }
  }, [currentMRequest?.requestId]);

  if (!documentItem) return null;

  const { docDesc, docName, deleteFlag, filePath } = documentItem;

  return (
    <MaterialDocumentItem
      name={docName}
      type={getFileTypeExt(filePath)}
      status={Boolean(deleteFlag)}
      description={docDesc}
    />
  );
};

export default ViewModalContent;
